import { useTranslation } from 'react-i18next';
import { Typography, Box, Button, Grid } from '@mui/material';
import React from 'react';
import { useNavigate } from "react-router-dom";
function NotFound(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return(
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography color="primary" variant="h4">{t("Nicht gefunden")}</Typography>
        </Grid>
        <Grid item xs={12}>
        <Typography variant="body1">{t("Scheint als wäre dieses Programm noch nicht entwickelt.")}</Typography>
        </Grid>
        <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={() => navigate('/', {replace: true})}>{t("Zum Verteiler")}</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default NotFound;
